import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, Heart, MessageCircle } from 'lucide-react';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-pink-50 flex flex-col items-center py-10 px-4">
      {/* 타이틀 영역 */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-pink-600 flex items-center justify-center gap-2 mb-2">
          <Sparkles /> Cutie Lab <Sparkles />
        </h1>
        <p className="text-gray-600">나를 찾아 떠나는 귀여운 여행</p>
      </div>

      {/* 테스트 목록 카드 */}
      <div className="grid gap-6 w-full max-w-md">
        {/* 1. 송년회 테스트 카드 */}
        <button 
          onClick={() => navigate('/party')}
          className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow border-2 border-pink-100 text-left group"
        >
          <h2 className="text-xl font-bold text-gray-800 mb-1 group-hover:text-pink-600 transition-colors">🍺 직장인 송년회 MBTI</h2>
          <p className="text-gray-500 text-sm">내 회식 스타일은 어떨까?</p>
        </button>

        {/* 2. 빠순사주 카드 */}
        <button 
          onClick={() => navigate('/idol')}
          className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow border-2 border-purple-100 text-left group"
        >
          <h2 className="text-xl font-bold text-gray-800 mb-1 group-hover:text-purple-600 transition-colors">💎 빠순사주 테스트</h2>
          <p className="text-gray-500 text-sm">나의 덕질 성향 분석하기</p>
        </button>

        {/* 3. 환승연애 테스트 카드 (디자인 통일!) */}
        <button 
          onClick={() => navigate('/transfer')}
          className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow border-2 border-rose-100 text-left group"
        >
          <h2 className="text-xl font-bold text-gray-800 mb-1 flex items-center gap-2 group-hover:text-rose-600 transition-colors">
            <MessageCircle size={20} className="text-rose-400" /> 내가 환승연애 출연자라면?
          </h2>
          <p className="text-gray-500 text-sm">나의 하우스 내 포지션 분석</p>
        </button>

        {/* 나중에 추가될 테스트 자리 */}
        <div className="border-2 border-dashed border-gray-200 p-6 rounded-2xl flex items-center justify-center bg-gray-50 bg-opacity-50">
          <p className="text-gray-400 text-sm flex items-center gap-1">새로운 테스트 준비 중... <Heart className="w-4 h-4 animate-pulse" /></p>
        </div>
      </div>
    </div>
  );
};

export default Home;
